import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Activity, ObjectType, ActivityLogType } from 'app/types';

@Injectable({
    providedIn: 'root'
})
export class ActivityHelper {
    private readonly translateService = inject(TranslateService);

    public getActivityText(activity: Activity) {
        if (activity.objectTypeId === ObjectType.Agreement) {
            // Agreement
            switch (activity.activityLogTypeId) {
                case ActivityLogType.CreatedAgreement:
                    return this.translateService.instant('FEATURES.ACTIVITY.CREATED_AGREEMENT', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedAgreement:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_AGREEMENT', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.DeletedAgreement:
                    return this.translateService.instant('FEATURES.ACTIVITY.DELETED_AGREEMENT', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedAgreementTerminated:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_AGREEMENT_TERMINATED', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedAgreementReplaced:
                    return this.translateService.instant(
                        'FEATURES.ACTIVITY.MODIFIED_AGREEMENT_TERMINATED_AND_REPLACED_BY',
                        {
                            createdBy: activity.createdBy,
                            name: activity.objectName
                        }
                    ) as string;
                case ActivityLogType.ModifiedAgreementValidTo:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_AGREEMENT_VALID_TO', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedAgreementNotifyPeriod:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_AGREEMENT_NOTIFY_PERIOD', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.RenewalAgreement:
                    return this.translateService.instant('FEATURES.ACTIVITY.RENEWAL_AGREEMENT', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.MovedUser:
                    return this.translateService.instant('FEATURES.ACTIVITY.MOVED_AGREEMENT_USER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.SentForRenegotiate:
                    return this.translateService.instant('FEATURES.ACTIVITY.SENT_FOR_RENEGOTIATE', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                default:
                    return 'TODO';
            }
        } else if (activity.objectTypeId === ObjectType.Customer) {
            // Customer
            switch (activity.activityLogTypeId) {
                case ActivityLogType.CreatedCustomer:
                    return this.translateService.instant('FEATURES.ACTIVITY.CREATED_CUSTOMER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.DeletedCustomer:
                    return this.translateService.instant('FEATURES.ACTIVITY.DELETED_CUSTOMER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedCustomer:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_CUSTOMER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                default:
                    return '-';
            }
        } else if (activity.objectTypeId === ObjectType.Counterpart) {
            // Counterpart
            switch (activity.activityLogTypeId) {
                case ActivityLogType.CreatedCounterpart:
                    return this.translateService.instant('FEATURES.ACTIVITY.CREATED_COUNTERPART', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.DeletedCounterpart:
                    return this.translateService.instant('FEATURES.ACTIVITY.DELETED_COUNTERPART', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedCounterpart:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_COUNTERPART', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                default:
                    return '-';
            }
        } else if (activity.objectTypeId === ObjectType.User) {
            // User
            switch (activity.activityLogTypeId) {
                case ActivityLogType.CreatedUser:
                    return this.translateService.instant('FEATURES.ACTIVITY.CREATED_USER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.DeletedUser:
                    return this.translateService.instant('FEATURES.ACTIVITY.DELETED_USER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.ModifiedUser:
                    return this.translateService.instant('FEATURES.ACTIVITY.MODIFIED_USER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                case ActivityLogType.MovedUser:
                    return this.translateService.instant('FEATURES.ACTIVITY.MOVED_USER', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                default:
                    return '-';
            }
        } else if (activity.objectTypeId === ObjectType.Inbox) {
            // Inbox
            switch (activity.activityLogTypeId) {
                case ActivityLogType.NewInboxItem:
                    return this.translateService.instant('FEATURES.ACTIVITY.NEW_INBOX_ITEM', {
                        createdBy: activity.createdBy,
                        name: activity.objectName
                    }) as string;
                default:
                    return '-';
            }
        }

        return '-';
    }
}
